
(function() {
  var result = { translations: { "da": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albansk", "sq-al": "Albansk - Albanien", "ar": "Arabisk", "ar-dz": "Arabisk - Algeriet", "ar-bh": "Arabisk - Bahrain", "ar-eg": "Arabisk - Egypten", "ar-iq": "Arabisk - Irak", "ar-jo": "Arabisk - Jordan", "ar-kw": "Arabisk - Kuwait", "ar-lb": "Arabisk - Libanon", "ar-ly": "Arabisk - Libyen", "ar-ma": "Arabisk - Marokko", "ar-om": "Arabisk - Oman", "ar-qa": "Arabisk - Qatar", "ar-sa": "Arabisk - Saudi-Arabien", "ar-sd": "Arabisk - Sudan", "ar-sy": "Arabisk - Syrien", "ar-tn": "Arabisk - Tunesien", "ar-ae": "Arabisk - De Forenede Arabiske Emirater", "ar-ye": "Arabisk - Yemen", "as": "Assamesisk", "az": "Aserbajdsjansk", "hy": "Armensk", "eu": "Baskisk", "be": "Hviderussisk", "be-by": "Hviderussisk - Hviderusland", "bn": "Bengalsk", "bg": "Bulgarsk", "bg-bg": "Bulgarsk - Bulgarien", "bs": "Bosnisk", "ca": "Katalansk", "ca-es": "Katalansk - Katalansk", "zh": "Kinesisk", "zh-cn": "Kinesisk - Forenklet", "zh-hk": "Kinesisk - Hong Kong", "zh-mo": "Kinesisk - Macau", "zh-sg": "Kinesisk - Singapore", "zh-tw": "Kinesisk - Traditionelt", "zh-chs": "Kinesisk (forenklet)", "zh-cht": "Kinesisk (traditionelt)", "zh-hans": "Kinesisk (forenklet Han)", "zh-hant": "Kinesisk (traditionel Han)", "hr": "Kroatisk", "hr-hr": "Kroatisk - Kroatien", "cs": "Tjekkisk", "cs-cz": "Tjekkisk - Tjekkiet", "da": "Dansk", "da-dk": "Dansk - Danmark", "nl": "Hollandsk", "nl-be": "Hollandsk - Belgien", "nl-ch": "Hollandsk - Schweiz", "nl-lu": "Hollandsk - Luxembourg", "nl-nl": "Hollandsk - Holland", "en": "Engelsk", "en-ae": "Engelsk - De Forenede Arabiske Emirater", "en-au": "Engelsk - Australien", "en-be": "Engelsk - Belgien", "en-ca": "Engelsk - Canada", "en-ch": "Engelsk - Schweiz", "en-cn": "Engelsk - Kina", "en-de": "Engelsk - Tyskland", "en-ee": "Engelsk - Estland", "en-fr": "Engelsk - Frankrig", "en-hk": "Engelsk - Hong Kong", "en-in": "Engelsk - Indien", "en-ie": "Engelsk - Irland", "en-ke": "Engelsk - Kenya", "en-lu": "Engelsk - Luxembourg", "en-my": "Engelsk - Malaysia", "en-mt": "Engelsk - Malta", "en-mx": "Engelsk - Mexico", "en-nl": "Engelsk - Holland", "en-nz": "Engelsk - New Zealand", "en-ph": "Engelsk - Filippinerne", "en-pk": "Engelsk - Pakistan", "en-se": "Engelsk - Sverige", "en-sg": "Engelsk - Singapore", "en-za": "Engelsk - Sydafrika", "en-gb": "Engelsk - Storbritannien", "en-us": "Engelsk - USA", "en-zw": "Engelsk - Zimbabwe", "et": "Estisk", "et-ee": "Estisk - Estland", "fo": "F\xE6r\xF8sk", "fa": "Farsi", "fi": "Finsk", "fi-fi": "Finsk - Finland", "fil": "Filippinsk", "fr": "Fransk", "fr-be": "Fransk - Belgien", "fr-ca": "Fransk - Canada", "fr-fr": "Fransk - Frankrig", "fr-lu": "Fransk - Luxembourg", "fr-mc": "Fransk - Monaco", "fr-ch": "Fransk - Schweiz", "fr-tn": "Fransk - Tunesien", "gl": "Galisisk", "ka": "Georgisk", "de": "Tysk", "de-at": "Tysk - \xD8strig", "de-de": "Tysk - Tyskland", "de-gr": "Tysk - Gr\xE6kenland", "de-li": "Tysk - Liechtenstein", "de-lu": "Tysk - Luxembourg", "de-ch": "Tysk - Schweiz", "el": "Gr\xE6sk", "el-cy": "Gr\xE6sk - Cypern", "el-gr": "Gr\xE6sk - Gr\xE6kenland", "gu": "Gujarati", "ha": "Hausa", "he": "Hebraisk", "he-il": "Hebraisk - Israel", "iw-il": "Hebraisk - Israel", "hi": "Hindi", "hi-in": "Hindi - Indien", "hu": "Ungarsk", "hu-hu": "Ungarsk - Ungarn", "is": "Islandsk", "is-is": "Islandsk - Island", "id": "Indonesisk", "in-id": "Indonesisk - Indonesien", "ga": "Irks", "ga-ie": "Irsk - Irland", "it": "Italiensk", "it-it": "Italiensk - Italien", "it-ch": "Italiensk - Schweiz", "ja": "Japansk", "ja-jp": "Japansk - Japan", "kn": "Kannada", "kk": "Kasakhisk", "kok": "Konkani", "ko": "Koreansk", "ko-kr": "Koreansk - Sydkorea", "ku": "Kurdisk", "ky": "Kirgisisk", "ky-kg": "Kirgisisk", "lo": "Lao", "lv": "Lettisk", "lv-lv": "Lettisk - Letland", "lt": "Litauisk", "lt-lt": "Litauisk - Litauen", "mk": "Makedonsk", "mk-mk": "Makedonsk - Makedonien", "ml": "Malayalam", "ms": "Malaysisk", "ms-bn": "Malaysisk - Brunei", "ms-my": "Malaysisk - Malaysia", "mt": "Maltesisk", "mt-mt": "Maltesisk - Malta", "mr": "Marathi", "mn": "Mongolsk", "my": "Burmesisk", "my-mm": "Burmesisk - Myanmar (Burma)", "ne": "Nepalesisk", "no": "Norsk", "nb": "Norsk bokm\xE5l", "nb-no": "Norsk Bokmal - Norge", "no-no": "Norsk - Norge", "pl": "Polsk", "pl-pl": "Polsk - Polen", "pt": "Portugisisk", "pt-br": "Portugisisk - Brasilien", "pt-pt": "Portugisisk - Portugal", "pa": "Punjabi", "pa-in": "Punjabi - Indien", "pa-pk": "Punjabi - Pakistan", "ro": "Rum\xE6nsk", "ro-ro": "Rum\xE6nsk - Rum\xE6nien", "ru": "Russisk", "ru-ru": "Russisk - Rusland", "rw-rw": "Kinyarwanda", "sa": "Sanskrit", "si": "Singalesiske", "sr": "Serbisk", "sr-ba": "Serbisk - Bosnien-Hercegovina", "sr-me": "Serbisk - Montenegro", "sr-rs": "Serbisk - Serbien", "sr-cs": "Serbisk - Serbien og Montenegro (tidligere)", "sk": "Slovakisk", "sk-sk": "Solvakisk - Slovakiet", "sl": "Slovensk", "sl-si": "Slovensk - Slovenien", "es": "Spansk", "es-ar": "Spansk - Argentina", "es-bo": "Spansk - Bolivia", "es-cl": "Spansk - Chile", "es-co": "Spansk - Colombia", "es-cr": "Spansk - Costa Rica", "es-cu": "Spansk - Cuba", "es-do": "Spansk - Den Dominikanske Republik", "es-ec": "Spansk - Ecuador", "es-sv": "Spansk - El Salvador", "es-gt": "Spansk - Guatemala", "es-hn": "Spansk - Honduras", "es-mx": "Spansk - Mexico", "es-ni": "Spansk - Nicaragua", "es-pa": "Spansk - Panama", "es-py": "Spansk - Paraguay", "es-pe": "Spansk - Peru", "es-pr": "Spansk - Puerto Rico", "es-es": "Spansk - Spanien", "es-us": "Spansk - USA", "es-uy": "Spansk - Uruguay", "es-ve": "Spansk - Venezuela", "sw": "Swahili", "sv": "Svensk", "sv-fi": "Svensk - Finland", "sv-se": "Svensk - Sverige", "sy": "Syrisk", "ta": "Tamilsk", "tt": "Tatarisk", "te": "Telugu", "th": "Thai", "th-th": "Thailandsk - Thailand", "tl": "Tagalog", "tr": "Tyrkisk", "tr-tr": "Tyrkisk - Tyrkiet", "uk": "Ukrainsk", "uk-ua": "Ukrainsk - Ukraine", "ur": "Urdu", "uz": "Usbekisk", "vi": "Vietnamesisk", "vi-vn": "Vietnamesisk - Vietnam", "yi": "Jiddisch", "zu": "Zulu" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.160",
    "ar-eg": "static-1.160",
    "ar-sa": "static-1.160",
    "ar": "static-1.160",
    "be": "static-1.160",
    "bg": "static-1.160",
    "bn": "static-1.160",
    "ca-es": "static-1.160",
    "ca": "static-1.160",
    "cs": "static-1.160",
    "da": "static-1.160",
    "de": "static-1.160",
    "el": "static-1.160",
    "en-gb": "static-1.160",
    "en": "static-1.160",
    "es-ar": "static-1.160",
    "es-es": "static-1.160",
    "es-mx": "static-1.160",
    "es": "static-1.160",
    "et": "static-1.160",
    "eu": "static-1.160",
    "fi": "static-1.160",
    "fr-ca": "static-1.160",
    "fr": "static-1.160",
    "gl": "static-1.160",
    "gu": "static-1.160",
    "he-il": "static-1.160",
    "he": "static-1.160",
    "hi": "static-1.160",
    "hr": "static-1.160",
    "hu": "static-1.160",
    "hy": "static-1.160",
    "id": "static-1.160",
    "is": "static-1.160",
    "it": "static-1.160",
    "ja": "static-1.160",
    "ka": "static-1.160",
    "kk": "static-1.160",
    "kn": "static-1.160",
    "ko": "static-1.160",
    "ky": "static-1.160",
    "lt": "static-1.160",
    "lv": "static-1.160",
    "mk": "static-1.160",
    "mn": "static-1.160",
    "mr": "static-1.160",
    "ms-my": "static-1.160",
    "ms": "static-1.160",
    "nl-be": "static-1.160",
    "nl-nl": "static-1.160",
    "nl": "static-1.160",
    "no": "static-1.160",
    "pl": "static-1.160",
    "pt-br": "static-1.160",
    "pt-pt": "static-1.160",
    "ro": "static-1.160",
    "ru": "static-1.160",
    "sk": "static-1.160",
    "sl": "static-1.160",
    "sq": "static-1.160",
    "sr": "static-1.160",
    "sv": "static-1.160",
    "sw": "static-1.160",
    "ta": "static-1.160",
    "te": "static-1.160",
    "th": "static-1.160",
    "tl": "static-1.160",
    "tr": "static-1.160",
    "uk": "static-1.160",
    "ur": "static-1.160",
    "vi": "static-1.160",
    "zh-cn": "static-1.160",
    "zh-hans": "static-1.160",
    "zh-hant": "static-1.160",
    "zh-hk": "static-1.160",
    "zh-tw": "static-1.160"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "da": { "i18n": { "duration": { "seconds": "{{ seconds }} sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t.", "hoursAndMinutes": "{{ hours }}t. {{ minutes }}min.", "days": "{{ days }}dg", "shortForm": { "seconds": "{{ seconds }}sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t", "days": "{{ days }}dg", "hoursAndMinutes": "{{ hours }}t {{ minutes }}min." } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, lokal {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "da": "static-7.1304"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1304",
    "ar-eg": "static-7.1304",
    "bg": "static-7.1304",
    "bn": "static-7.1304",
    "ca-es": "static-7.1304",
    "cs": "static-7.1304",
    "da": "static-7.1304",
    "de": "static-7.1304",
    "el": "static-7.1304",
    "en-gb": "static-7.1304",
    "en": "static-7.1304",
    "es-mx": "static-7.1304",
    "es": "static-7.1304",
    "et": "static-7.1304",
    "fi": "static-7.1304",
    "fr-ca": "static-7.1304",
    "fr": "static-7.1304",
    "he-il": "static-7.1304",
    "hi": "static-7.1304",
    "hr": "static-7.1304",
    "hu": "static-7.1304",
    "id": "static-7.1304",
    "it": "static-7.1304",
    "ja": "static-7.1304",
    "ko": "static-7.1304",
    "lt": "static-7.1304",
    "ms": "static-7.1304",
    "nl": "static-7.1304",
    "no": "static-7.1304",
    "pl": "static-7.1304",
    "pt-br": "static-7.1304",
    "pt-pt": "static-7.1304",
    "ro": "static-7.1304",
    "ru": "static-7.1304",
    "sk": "static-7.1304",
    "sl": "static-7.1304",
    "sv": "static-7.1304",
    "th": "static-7.1304",
    "tl": "static-7.1304",
    "tr": "static-7.1304",
    "uk": "static-7.1304",
    "vi": "static-7.1304",
    "x-pseudo": "static-7.1304",
    "zh-cn": "static-7.1304",
    "zh-hk": "static-7.1304",
    "zh-tw": "static-7.1304"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:da', {version: 'static-7.1304'}); }
})();



(function() {
  var result = { translations: { "da": { "videoPlayer": { "htmlTitle": "HubSpot-video", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot-video", "controls": { "audioPlayer": "Lydafspiller", "videoPlayer": "Videoafspiller", "play": "Afspil", "playVideo": "Afspil video", "pause": "Pause", "replay": "Afspil igen", "currentTime": "Nuv\xE6rende tid", "duration": "Varighed", "remainingTime": "Resterende tid", "fullscreen": "Fuldsk\xE6rm", "exitFullscreen": "Afslut fuldsk\xE6rm", "mute": "Sl\xE5 lyd fra", "unmute": "Sl\xE5 lyd til", "volumeLevel": "Lydstyrkeniveau", "captions": "Undertekster", "captionsOff": "Fra", "seekBar": "Juster position", "chapter": "Kapitel", "elapsedTime": "Tid g\xE5et: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Indstillinger for afspilning", "playbackRate": "Afspilningshastighed:", "quality": "M\xE6ngde:", "normal": "Normal", "auto": "(Auto)" }, "formModal": { "defaultThankYouMessage": "Tak for dit svar.", "inlineMessageButton": "Se video" }, "ctaModal": { "imgAlt": "Video-CTA" }, "errors": { "generic": { "heading": "Kunne ikke indl\xE6se video" }, "UNAUTHORIZED": { "heading": "Video blev ikke aktiveret" }, "VIDEO_NOT_FOUND": { "heading": "Video blev ikke fundet" }, "INVALID_URL": { "heading": "Video blev ikke fundet" }, "UNSUPPORTED_EMBED": { "heading": "Video ikke tilg\xE6ngelig", "extra": "Denne video kan ikke ses eksternt." }, "refreshLink": "Pr\xF8v igen" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "da": "static-1.26715"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.26715",
    "ar-eg": "static-1.26715",
    "bg": "static-1.26715",
    "bn": "static-1.26715",
    "ca-es": "static-1.26715",
    "cs": "static-1.26715",
    "da": "static-1.26715",
    "de": "static-1.26715",
    "el": "static-1.26715",
    "en-gb": "static-1.26715",
    "en": "static-1.26715",
    "es-mx": "static-1.26715",
    "es": "static-1.26715",
    "et": "static-1.26715",
    "fi": "static-1.26715",
    "fr-ca": "static-1.26715",
    "fr": "static-1.26715",
    "he-il": "static-1.26715",
    "hi": "static-1.26715",
    "hr": "static-1.26715",
    "hu": "static-1.26715",
    "id": "static-1.26715",
    "it": "static-1.26715",
    "ja": "static-1.26715",
    "ko": "static-1.26715",
    "lt": "static-1.26715",
    "ms": "static-1.26715",
    "nl": "static-1.26715",
    "no": "static-1.26715",
    "pl": "static-1.26715",
    "pt-br": "static-1.26715",
    "pt-pt": "static-1.26715",
    "ro": "static-1.26715",
    "ru": "static-1.26715",
    "sk": "static-1.26715",
    "sl": "static-1.26715",
    "sv": "static-1.26715",
    "th": "static-1.26715",
    "tl": "static-1.26715",
    "tr": "static-1.26715",
    "uk": "static-1.26715",
    "vi": "static-1.26715",
    "zh-cn": "static-1.26715",
    "zh-hk": "static-1.26715",
    "zh-tw": "static-1.26715"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:da', {version: 'static-1.26715'}); }
})();


